import type { HeaderContext } from '@tanstack/react-table';
import type { ProjectClips } from '@trinity/chat/types';
import { FilterableHeader } from './FilterableHeader';

type Props = HeaderContext<ProjectClips.Item, unknown>;

export const GoodQuoteHeader = ({ column }: Props) => (
  <FilterableHeader columnId={column.id}>Good Quote</FilterableHeader>
);

GoodQuoteHeader.displayName = 'ProjectClips.GoodQuoteHeader';
